module.exports = __webpack_public_path__ + "src/assets/img/girl_right_5.da0a7179.png";